import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";


export const getBpmnTaskApi = (async (search, id ,processId) => await http({

    url: ENDPOINTS.bpmnApi.Task.Detailsdictionary,
    method: 'get',
    params: {
        processId: processId,
        SearchString: search,
    }
})
    .then((respons) => (respons.data.Data))
)
